import React, { useState, useEffect } from "react";
import '../components/css/NoFeeAlert.css'
import { AlertCircleIcon } from "lucide-react";
import axios from "./../axios";
const NoFeeAlert = () => {

  const [pending_fee, setPending_fee] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("student_token"); // or pass from props/context

        const response = await axios.get('student/get_home_fee', {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ clean header
          },
        });

        console.log(response.data);
        if (response.data && response.data.balance !== undefined) {
          setPending_fee(response.data.balance);
        } else {
          setPending_fee(0);
        }

      } catch (error) {
        console.error('Error fetching balance:', error);
        setPending_fee(0);
      }
    };

    fetchProfile();
  }, []);

  return (
    <>
      {pending_fee > 0 ? (
        <>
          <div className="NoAlert">
            <AlertCircleIcon /> You have a pending balance of ₹{pending_fee}
          </div>
          <br />
        </>
      ) : (
        <></>
      )}


    </>
  )
}
export default NoFeeAlert;